type ScrollTarget = HTMLElement | string | null;

interface ScrollOptions {
  behavior?: 'auto' | 'smooth';
  block?: 'start' | 'center' | 'end' | 'nearest';
  inline?: 'start' | 'center' | 'end' | 'nearest';
  offset?: number; // Optional offset for scrolling
  focusScrolledEl?: boolean;
}

export const scrollToElement = (
  target: ScrollTarget,
  options: ScrollOptions = {
    behavior: 'smooth',
    block: 'start',
    focusScrolledEl: false
  }
): void => {
  let element: HTMLElement | null = null;

  // If target is a string, try to find the element
  if (typeof target === 'string') {
    element = document.querySelector(target);
  } else if (target instanceof HTMLElement) {
    element = target;
  }

  // If element is found, perform scroll with optional offset
  if (element) {
    const { offset, ...scrollOptions } = options;

    if (offset !== undefined) {
      // Calculate final position if offset is provided
      const position = element.getBoundingClientRect().top + window.scrollY + offset;

      window.scrollTo({
        top: position,
        behavior: scrollOptions.behavior
      });
    } else {
      // Use default scrollIntoView if no offset is provided
      element.scrollIntoView(scrollOptions);

      // Allow focusing on the scrolled element (accessibility: let screen reader announce the scrolled-to element)
      if (scrollOptions.focusScrolledEl) {
        element.focus({ preventScroll: true });
      }
    }
  }
};
